import React from "react";
import { FaProjectDiagram, FaCheckCircle, FaMoneyBillWave, FaUsers, FaClock } from "react-icons/fa";
import "./projectmanagement.css";
import Navbar from "../navbar/Navbar";
import image from "../../interior_assets/projectmanagement.jpeg";
import Footer from "../footer/Footer";
const benefits = [
    {
        icon: <FaProjectDiagram />,
        title: "Project Planning & Coordination",
        description:
            "We create detailed project timelines, outlining every phase from start to finish. Task delegation ensures each team member is responsible for specific areas, while resource management guarantees that materials and tools are available when needed. Regular updates and communication keep the project on track, ensuring smooth execution and timely delivery.",
    },
    {
        icon: <FaCheckCircle />,
        title: "Quality Assurance",
        description:
            "We prioritize quality at every stage of the project, conducting regular inspections and ensuring that all materials, finishes, and installations meet the highest standards. Our team monitors craftsmanship and adherence to design specifications, ensuring flawless execution and long-lasting results.",
    },
    {
        icon: <FaMoneyBillWave />,
        title: "Budget & Cost Control",
        description:
            "We provide clear, upfront budgeting and continuously monitor expenses throughout the project. Our team ensures that costs are kept within the agreed limits, making adjustments as needed to avoid overruns while maintaining high-quality results.",
    },
    {
        icon: <FaUsers />,
        title: "Team Supervision",
        description:
            "Our experienced supervisors manage and guide skilled professionals throughout the project, ensuring consistent quality and timely progress. Regular monitoring and on-site coordination maintain high standards, resolve issues quickly, and keep the project aligned with design goals.",
    },
    {
        icon: <FaClock />,
        title: "On-time Delivery",
        description:
            "We ensure that every project is completed within the agreed timeframe by closely monitoring progress and addressing challenges promptly. Our efficient planning, coordination, and team management guarantee timely delivery without compromising on quality.",
    },
];

const Projectmanagement = () => {
    return (
        <>
            <Navbar />
            <section className="" style={{ marginTop:"70px"}}>
                <div className="container  vm-container-project d-flex" >
                   
                    <div className="text-container">
                        <div className="vision">
                            <h4>Project Management</h4>
                            <p style={{ textAlign:"justify"}}>At First Sky Infra Interior, we take a structured and professional approach to managing interior projects from concept to completion. Our team ensures seamless coordination between design, procurement, and execution, maintaining the highest standards of quality and efficiency. With a keen focus on timelines, budget alignment, and attention to detail, we deliver hassle-free project execution. From planning and material selection to final inspection and handover, we manage every aspect meticulously—ensuring your dream space is completed on time, within budget, and to your utmost satisfaction.</p>
                            {benefits.map((benefit, index) => (
                                <ul key={index} style={{ lineHeight:1}}>
                                    <li>{benefit.title}</li>
                                </ul>
                            ))}

                        </div>

                    </div>
                    <div className="image-container-vm">
                        <img src={image} alt="Your Image" className="image-vm" />
                    </div>
                </div>

            </section>

            <section className="project-benefits-section">
                <div className="container">
                    {/* <h2 className="benefits-heading">Our Key Benefits</h2> */}
                    <div className="benefits-grid-project">
                        {benefits.map((benefit, index) => (
                            <div className="benefit-item-project" key={index}>
                                <div className="benefit-icon-project">{benefit.icon}</div>
                                <h3 className="benefit-title-project">{benefit.title}</h3>
                                <p className="benefit-description-project">{benefit.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Projectmanagement;
